<template>
    <div class="modal fade" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="viewModal">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento de Descargo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">                        
                        <div>
                            <div class="form-row">
                                <div class="form-group col-12 col-md-6">
                                    <label for="type_ship" class="badge badge-primary">Canal</label>
                                
                                    <select class="form-control" v-model="typeChanel" name="propulsion">
                                        <option v-for="chanel in typesChanel" :key="chanel.id" :value="chanel">{{ chanel.detail }}</option>
                                    </select>
                                </div>

                                <div class="form-group col-12 col-md-6">
                                    <label for="type_ship" class="badge badge-primary">Documento</label>
                                
                                    <select class="form-control" v-model="typeDoc" name="propulsion">
                                        <option v-for="document in typesDocument" :key="document.id" :value="document">{{ document.detail }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-12 col-md-4">
                                    <label for="number_doc" class="badge badge-primary">Numero Documento</label>
                                    
                                    <input type="number" class="form-control" name="number_doc" v-model="nDocumento" placeholder="0">     
                                </div>
                                <div class="form-group col-12 col-md-4">
                                    <label for="date_doc" class="badge badge-primary">Fecha Documento</label>
                                    
                                    <input type="date" class="form-control" name="date_doc" v-model="dateDocumento" placeholder="dd/mm/YYYY">     
                                </div>
                                <div class="form-group col-12 col-md-4">
                                    <label for="importe" class="badge badge-primary">Importe</label>
                                    
                                    <input type="number" class="form-control" name="importe" v-model="importe" placeholder="0">     
                                </div>
                            </div>                            
                        </div>
                    </div>                                           
                    
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-success" @click="mAppendDocument"><font-awesome-icon icon="check" size="lg" /></button>
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>                        
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
const qs= require('qs');

export default {
    name:'modal-document',
    props:{
        idModal:String,
        viewModal:Boolean,
        typesDocument:Array,
        typesChanel:Array
    },
    data() {
        return {
            importe: null,
            typeDoc:[],
            typeChanel:[],
            nDocumento:null,
            dateDocumento:null
        }
    },
    mounted(){
        this.stopModal()
    },
    methods:{
        stopModal(){
            $('.modal').modal({
                keyboard: false,
                show:false,
                backdrop:'static'
            });
        },
        mAppendDocument(){
            // console.log(this.typeDoc);
            // console.log(this.typeChanel)
            // console.log(this.nDocumento)
            // console.log(this.importe)
            if( this.typeDoc && this.typeChanel && this.nDocumento > 0 && this.importe > 0 && this.dateDocumento.length >= 9 && this.dateDocumento.length<=10){
                let auxDocument={
                    idChanel:this.typeChanel.id,
                    detailChanel:this.typesChanel.detail,
                    idDocument:this.typeDoc.id,
                    detailDocument:this.typeDoc.detail,
                    numberDoc:this.nDocumento,
                    dateDoc:this.dateDocumento,
                    importe:this.importe
                }
                this.$store.dispatch('sDocDebts/addDocument', auxDocument);
                this.nDocumento=null;
                this.importe=null;
                this.dateDocumento=null;
            }else{
                toastr.info('Complete los campos', 'Advertencia');
            }
        }
    },
    filters: {
        round(value) {
            return value.toFixed(2);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/finanzas/ModalDocument.vue